<template>
  <div class="product-configs-container">
    <div v-if="headline" class="product-configs-headline">
      {{ headline }}
    </div>

    <div class="product-configs">
      <BaseProductConfigurationItem
        v-for="(item, index) in items"
        :key="index"
        :title="item[keyTitle]"
        :selected="item[keySelected] === selected"
        :disabled="
          (isFromQRCode && item[keySelected] !== selected) ||
            item.disabled
        "
        @click="
          isFromQRCode || item[keySelected] == selected
            ? null
            : $emit('change', item)
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseProductConfigurations',

  props: {
    headline: {
      type: String,
      default: '',
    },
    keyTitle: {
      type: String,
      required: true,
    },
    keySelected: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
    isFromQRCode: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseProductConfigurationItem: () =>
      import(
        '@/components/base/product/BaseProductConfigurationItem'
      ),
  },
}
</script>

<style lang="stylus" scoped>
.product-configs-container
	display flex
	flex-direction column
	gap: 16px

// BaNANA Styles
.-is-bnn {
	.product-configs {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;

		@media screen and (max-width: 768px) {
			flex-direction: row;
		}
	}

	.product-configs-headline {
		font-size: 14px
		color: rgba(0, 0, 0, 0.45);
	}
}

// Studio7 Styles
.product-configs{
	display: grid;
	gap: 16px;
	grid-template-columns: repeat(1, 1fr);

	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
}
</style>
